<template>
    <section v-if="json" class="page-404">
        <div class="thefold" data-aos="custom-fade-in" >
            <div class="bgimg parallax-hook"
                 :style="`background-image:url('${window.config.json.artifacts.generalBg}')`"
            ></div>
            <div class="capper">
                <div class="capper-padded-4x">
                    <div class="lr">
                        <div class="l">
                            <img v-if="json?.pageNotFoundImage?.[0]?.url" :alt="json.pageNotFoundImage?.[0]?.title"  :src="json?.pageNotFoundImage?.[0]?.url" />
                        </div>
                        <div class="r">
                            <h3 v-if="json.subtitle">{{json.subtitle}}</h3>
                            <h1>{{json.title}}</h1>
                            <div class="txt" v-html="json.body"></div>
                            <div class="btn-outer" ref="btnOuter">
                                <Link
                                    v-if="json?.linkout?.url"
                                    :href="(json?.linkout?.url === '/home') ? '/' : json?.linkout?.url"
                                    :target="json?.linkout?.target"
                                    :label="gh.removeTags(json?.linkout?.label)"
                                    :isButton="true"
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>
<script>
import gh from '@/helpers/gh'
import axios from 'axios'
import Link from "@/components/pieces/Link.vue";
//import gh from '@/helpers/gh'
export default {
    name: "PageNotFound",
    components: {
        Link
    },
    data () {
        return {
            gh: gh,
            window: window,
            json: null,
            transition: false,
        }

    },
    created () {
    },
    mounted () {
        const turl = gh.formatFeedUrl('page-not-found')
        axios.get((turl))
            .then((res) => {
                this.json = res.data
                this.reveal()
            }).catch((e) => {
                console.error('Error',e)
        })
    },
    methods: {
        reveal () {

        },
        unreveal () {

        },
    }
}
</script>
